var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "highlight-card",
    class: {
      'is-processing': _vm.isProcessing
    }
  }, [_c('div', {
    staticClass: "highlight-thumb"
  }, [_vm.video.thumbnail && !_vm.isProcessing ? _c('img', {
    staticClass: "highlight-thumb-img",
    attrs: {
      "src": _vm.video.thumbnail,
      "alt": _vm.video.title
    }
  }) : _vm.video.videoUrl && !_vm.isProcessing ? _c('video', {
    staticClass: "highlight-thumb-img",
    attrs: {
      "src": ((_vm.video.videoUrl) + "#t=0.5"),
      "preload": "metadata",
      "muted": "",
      "playsinline": "",
      "tabindex": "-1"
    },
    domProps: {
      "muted": true
    }
  }) : _c('div', {
    staticClass: "highlight-thumb-placeholder"
  }), !_vm.isProcessing && !_vm.purchased ? _c('span', {
    staticClass: "gems-badge"
  }, [_c('img', {
    attrs: {
      "src": "/assets/event-highlights/gems.svg",
      "alt": ""
    }
  }), _vm._v(" " + _vm._s(_vm.video.points) + " ")]) : _vm._e(), !_vm.isProcessing ? _c('a', {
    staticClass: "highlight-play",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('play', _vm.video);
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/assets/event-highlights/play_btn.svg",
      "alt": "Play"
    }
  })]) : _vm._e(), _vm.isProcessing ? _c('div', {
    staticClass: "hl-status-overlay"
  }, [_c('div', {
    staticClass: "hl-status-spinner",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('strong', [_vm._v("Processing your highlight…")]), _c('span', [_vm._v("This can take a few minutes. Check back shortly.")])]) : _vm._e()]), _c('h4', {
    staticClass: "highlight-title"
  }, [_vm._v(_vm._s(_vm.video.title))]), _c('div', {
    staticClass: "hl-meta"
  }, [_c('div', {
    staticClass: "hl-meta-item"
  }, [_c('img', {
    attrs: {
      "src": "/assets/event-highlights/calender.svg",
      "alt": ""
    }
  }), _c('span', [_c('small', [_vm._v("Event Date")]), _vm._v(" " + _vm._s(_vm.video.eventDate) + " ")])]), _c('div', {
    staticClass: "hl-meta-item"
  }, [_c('img', {
    attrs: {
      "src": "/assets/event-highlights/clock.svg",
      "alt": ""
    }
  }), _c('span', [_c('small', [_vm._v(_vm._s(_vm.isProcessing ? "Status:" : "Expiry Date:"))]), _vm._v(" " + _vm._s(_vm.isProcessing ? "Processing" : _vm.video.expiryDate) + " ")])])]), _c('div', {
    staticClass: "highlight-actions"
  }, [_vm.isProcessing ? _c('span', {
    staticClass: "hl-btn hl-btn--download is-disabled"
  }, [_c('span', [_vm._v("Processing")])]) : _c('a', {
    staticClass: "hl-btn hl-btn--download",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('download', _vm.video);
      }
    }
  }, [_c('span', [_vm._v("Download")])]), _vm.purchased && !_vm.isProcessing ? _c('a', {
    staticClass: "highlight-delete-btn",
    attrs: {
      "href": "javascript:void(0)",
      "aria-label": "Delete"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('delete', _vm.video);
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/assets/event-highlights/delete_btn.svg",
      "alt": "Delete"
    }
  })]) : _vm._e()])]);
}
var staticRenderFns = []

export { render, staticRenderFns }